package com.eladfinish.bible.contest.screens.browse.usecases

import androidx.compose.ui.text.TextRange
import com.eladfinish.bible.contest.constants.ColorConstants
import com.eladfinish.bible.contest.constants.StringConstants
import com.eladfinish.bible.contest.extensions.end
import com.eladfinish.bible.contest.extensions.start
import com.eladfinish.bible.contest.text.SpanType
import com.eladfinish.bible.contest.text.SpannedRange
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

class MakeOtiotAliyahSmallerUseCase {

    companion object {
        private const val OTIOT_ALIYAH_RELATIVE_SIZE = 0.6f
    }

    operator fun invoke(
        content: String,
    ): ImmutableList<SpannedRange> {
        return StringConstants.Regex.OTIOT_ALIYAH.toRegex().findAll(content).map {
            listOf(
                SpannedRange(
                    spanType = SpanType.RelativeSize(proportion = OTIOT_ALIYAH_RELATIVE_SIZE),
                    textRange = TextRange(start = it.start, end = it.end),
                ),
                SpannedRange(
                    spanType = SpanType.ForegroundColor(color = ColorConstants.INDIGO_DARK),
                    textRange = TextRange(start = it.start, end = it.end),
                )
            )
        }.flatten()
            .toImmutableList()

    }
}
